import React from 'react';
import { RestrictedComponent } from '../../ui-components/RestrictedComponent';
import Wiki from './Wiki';

export const WikiPageWrapper = () => (
  <RestrictedComponent permission='search_product'>
    <Wiki />
  </RestrictedComponent>
);
